import {
  FileExcelOutlined,
  InfoCircleOutlined
} from "@ant-design/icons";
import { ConfigProvider, Pagination, Tooltip, Typography } from "antd";
import { getListCustomerUpdateHistory, ICustomerDetail_V4, ICustomerUpdateHistory } from "../../../../api/customer/customerApi";
import React, { useEffect, useState } from "react";
import useLoading from "../../../../hook/useLoading";
import useToast from "../../../../hook/useToast";
import { formatNumber } from "../../../../services/mixin";
import { dataPagination } from "../../../../until";
import { PaginationProps } from "antd/lib";
import viVN from 'antd/locale/vi_VN';
import { URL_AVATAR } from "../../../../env";
import { avatarDefault, noData } from "../../../../components/ExportImgFigma";
import { NodataTable } from "../../../../components/NoDataTable";
import { LogHistoryType } from "../../../../services/data";

const { Text } = Typography;

const activities = [
  {
    date: "15/01/2024",
    time: "14:20",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "admin@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin chăm sóc dịch vụ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      {
        text: "Đã tạo thông tin liên hệ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      { text: "Số điện thoại đã được bổ sung 0344735061" },
    ],
  },
  {
    date: "02/01/2024",
    time: "08:00",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "seratima@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin hồ sơ khách hàng",
        vehicles: [
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
    ],
  },
  {
    date: "01/01/2024",
    time: "14:20",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "admin@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin chăm sóc dịch vụ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      {
        text: "Đã tạo thông tin liên hệ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      { text: "Số điện thoại đã được bổ sung 0344735061" },
    ],
  },
  {
    date: "01/01/2024",
    time: "7:20",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "admin@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin chăm sóc dịch vụ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      {
        text: "Đã tạo thông tin liên hệ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      { text: "Số điện thoại đã được bổ sung 0344735061" },
    ],
  },
];

export interface IDataFilter {
  search?: string;
  adminId?: number
}

// bộ lọc lớn
const dataDefaulFilter = {
} as IDataFilter
interface Props {
  infoCustomer?: ICustomerDetail_V4;
}

const UpdateHistory: React.FC<Props> = ({
  infoCustomer
}) => {

  useEffect(() => {
    return () => {

    }
  }, [])

  const pushLoading = useLoading()
  const pushToast = useToast();

  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });

  const [listCustomerUpdateHistory, setListCustomerUpdateHistory] = useState<ICustomerUpdateHistory[]>([])

  const gListCustomerUpdateHistory = async (pageCurent: number = 1, pageSize: number = 20) => {
    if (!infoCustomer?.id) return
    pushLoading(true)
    const result = await getListCustomerUpdateHistory(
      infoCustomer?.id,
      pageSize, pageCurent, undefined, undefined,
      LogHistoryType.CUSTOMER
    )
    if (result?.status) {
      setListCustomerUpdateHistory(result.data)
      setPagination({ current: pageCurent, total: result.total, pageSize: pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    gListCustomerUpdateHistory(pageNumber, pageSize)
  }


  useEffect(() => {
    if (infoCustomer?.id) {
      gListCustomerUpdateHistory()
    }
  }, [infoCustomer?.id])

  return (

    pagination.total ?
      <div className="custom-page-css flex flex-col justify-between  h-full">
        <div className="activity-timeline">
          {
            listCustomerUpdateHistory.map((item, i) => {
              const { admin, detail, timestamp } = item
              const [date, time] = timestamp.split(" ")
              return (


                <div
                  key={i}
                  className={`timeline-item ${i === activities.length - 1 ? "is-last" : ""}`}
                >
                  {/* Line trong item */}
                  {
                    i !== activities.length - 1 &&
                    <div className="timeline-line" />
                  }

                  {/* Cột thời gian */}
                  <div className="timeline-time">
                    <Text>{date}</Text> <br />
                    <Text> {time} </Text>
                  </div>

                  {/* Avatar */}
                  <div className="timeline-center">
                    <div className="timeline-avatar-icon">
                      <img
                        height='100%'
                        src={`${URL_AVATAR + admin.img}`}
                        alt="THACO AUTO CRM"
                        onError={(e) => {
                          e.currentTarget.src = avatarDefault;
                        }}
                      />
                    </div>
                  </div>

                  {/* Nội dung */}
                  <div className="timeline-content">
                    <div className="timeline-user">
                      <Text>{admin.fullname?.length ? admin.fullname : "admin"} </Text>
                      <span className="cl096DD9 mr-4px">
                        {admin.code?.length ? `( ${admin.code} )` : ""}
                      </span>
                      {/* <Text type="secondary">| {admin.}</Text> */}
                    </div>
                    <div className="timeline-email">{admin.email}</div>

                    <div className="group-timeline-action">
                      {
                        detail.map((detailItem, j) => (
                          <div
                            key={j}
                            className="timeline-action"
                          >
                            <span>{detailItem.action}</span>
                            {
                              detailItem.descriptions.length > 1 ? (
                                <Tooltip
                                  placement="right"
                                  color="white"
                                  overlayClassName="content-tooltip-420-300"
                                  title={
                                    <div className="t-cotent-p-12">
                                      {
                                        detailItem.descriptions.map((descriptions, k) => (
                                          <div
                                            key={k}
                                            className="vehicle-item"
                                          >
                                            <div className="vehicle-info">
                                              <div className="vehicle-name">
                                                <Text strong>{descriptions}</Text>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      }
                                    </div>
                                  }
                                >
                                  <div className="count-number-E6F7FF">
                                    {detailItem.descriptions.length}
                                    <InfoCircleOutlined className="info-icon" />
                                  </div>
                                </Tooltip>
                              ) : (
                                <div className="vehicle-info">
                                  <div className="vehicle-name">
                                    <Text strong>{detailItem.descriptions}</Text>
                                  </div>
                                </div>
                              )
                            }
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              className='rs-pagination'
              showSizeChanger
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              pageSizeOptions={['10', '20', '50', '100']}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
      </div>

      :

      <div className="p-5 custom-page-css flex items-center flex-col">
        <br />
        <img src={noData} alt="No data" style={{ maxWidth: 300 }} />
        <br />
        <span className="">Không có dữ liệu</span>
        <br />
      </div>
  )
}
export default UpdateHistory
